import publicIP from 'react-native-public-ip';
import post from './post.js';

/**
 * @param type
 * @param id
 * @param meta
 * @param isMobile
 * @param isFail
 * @param isProduction
 * @returns {Promise<void>}
 */
async function log(type, id, meta, isMobile, isFail, isProduction) {
  if (isProduction === undefined) {
    throw 'Missing isProduction flag.';
  }
  if (id === null || typeof id !== 'object') {
    throw 'The event user-type id must be an object.';
  }
  const idType = Object.keys(id)[0];
  const ip = await publicIP();

  /**
   * Send request to API Gateway
   */
  return await post({
    type: type.toLowerCase(),
    [idType]: id[idType],
    idType,
    isMobile: isMobile || false,
    eventTime: Math.floor(Date.now() / 1000),
    isProduction,
    ip,
    meta
  });
}
export default log;